import React from 'react';
import { FormControlLabel, FormGroup, RadioGroup } from '@material-ui/core';
import { Form, Input, Dropdown } from 'semantic-ui-react';
// import { DatePicker, TimePicker } from 'antd';
import Datetime from "react-datetime";

import CreateContext from './../../store/CreateContext';
import { RadioSelect, CheckSelect } from './../../components/RadioButtons';
import Header from './../../components/Header';
import CircleButton from './../../components/CircleButton';
import { Daily, Montly } from './../../model/';
import { Days, Frequency, Months, AllDays } from './config';
import './styles.scss';

/*=============================================
=            Schedule Report                  =
=============================================*/

function ScheduleReport() {
  const context = React.useContext(CreateContext);
  const [email, setEmail] = React.useState(undefined);
  const [emailAdd, setEmailAdd] = React.useState(false);

  const CheckBuilder = ({ data, handler, type }) => {
    return (
      <FormGroup>
        {data.map((item, ind) => (
          <FormControlLabel
            control={
              <CheckSelect
                icon={'check_circle'}
                handler={() => handler(item, type)}
                selected={context.config[type][item.value]}
                id={ind}
              ></CheckSelect>
            }
            label={item.label}
          />
        ))}
      </FormGroup>
    );
  };

  function handleChangeDateTime(data) {
    if (data.id === 'startDate') {
      context.update_config({ key: 'startDate', value: { value: data.value, dateString: data.dateString } });
    } else if (data.id === 'endDate') {
      context.update_config({ key: 'endDate', value: { value: data.value, dateString: data.dateString } });
    } else if (data.id === 'hour') {
      context.update_config({ key: 'hour', value: { value: data.value, timeString: data.timeString } });
    }
  }
  function handleChangeDay(evt, data) {
    context.update_config({ key: 'day', value: data.value });
  }

  function handleChange(evt) {
    // console.log('this is the selected --->',evt.target, type);
    if (evt.target.value) {
      context.set_frequency(evt.target.value);
      if (evt.target.value === 'Daily') {
        context.update_config({ key: 'Monthly', value: { ...Montly() } });
      } else if (evt.target.value === 'Monthly') {
        context.update_config({ key: 'Daily', value: { ...Daily() } });
      }
    }
  }

  function onUpdateRecurrance(item, type) {
    if (type === 'Daily') {
      context.config[type][item.value] = !context.config[type][item.value];
      context.update_config({ key: 'Daily', value: { ...context.config[type] } });
    } else if (type === 'Monthly') {
      context.config[type][item.value] = !context.config[type][item.value];
      context.update_config({ key: 'Monthly', value: { ...context.config[type] } });
    }

  }

  function onChangeEmail(evt, data) {
    if (data.value) {
      // console.log('data.value', data.value);
      // if(validateEmail(email)){
      if (validateEmail(data.value)) {
        // console.log('email-->', email);
        setEmail(data.value);
        if (!emailAdd) {
          setEmailAdd(true);
        }
      } else {
        setEmail(data.value);
        setEmailAdd(false);
      }
    } else {
      setEmail('');
      setEmailAdd(false);
    }
  }

  function validateEmail(email) {
    const regexEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    return regexEmail.test(email);
  }
  function onAddEmail() {
    context.add_email(email);
    setEmail('');
    setEmailAdd(false);
  }
  function onADD(evt) {
    if (validateEmail(email) && evt.key === 'Enter') {
      onAddEmail();
    }
  }



  return (
    <div hidden={context.report_type === 'scheduled' ? false : true}>
      <Header
        as='h6'
        icon='fas fa-user-clock fa-lg mr-2'
        title='Scheduled'
      />
      <div className='col-md-12'>
        <div className='row'>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-6 d-flex justify-content-end'>
                <p className='schedule-title'>Frecuency</p>
              </div>
              <div className='col-md-6'>
                <RadioGroup aria-label="frequency" id='frequency' name="frequency" value={context.config.frequency} onChange={(event) => {
                  handleChange(event);
                }}>
                  {
                    Frequency.map((item, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          value={item.value}
                          id={index}
                          control={
                            <RadioSelect />
                          }
                          label={item.label}
                        />
                      );
                    })
                  }
                </RadioGroup>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-6 d-flex justify-content-end'>
                <p className='schedule-title'>Week Days</p>
              </div>
              <div className='col-md-6'>
                {
                  context.config.frequency === 'Daily' ?
                    <CheckBuilder data={Days} handler={onUpdateRecurrance} type='Daily' /> :
                    <CheckBuilder data={Months} handler={onUpdateRecurrance} type='Monthly' />
                }
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-12'>
                <label className='schedule-label'>Start Date</label>
                {/* <DatePicker placeholder={'Start Date'} className={'datetime-picker-schedule'} value={context.config.startDate.value} format={'YYYY-MM-DD'} bordered={true} onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'startDate' }); }} /> */}
                <Datetime
                  timeFormat={false}
                  inputProps={{ placeholder: "Start Date" }}
                  value={context.config.startDate.value}
                  onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'startDate' }); }} />

              </div>
              <div className='col-md-12'>
                <label className='schedule-label'>End Date</label>
                {/* <DatePicker placeholder={'End Date'} className={'datetime-picker-schedule'} value={context.config.endDate.value} format={'YYYY-MM-DD'} bordered={true} onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'endDate' }); }} /> */}
                <Datetime
                  timeFormat={false}
                  inputProps={{ placeholder: "End Date" }}
                  value={context.config.endDate.value}
                  onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'endDate' }); }} />
              </div>
              <div className='col-md-12' hidden={context.config.frequency === 'Daily' ? true : false}>
                <label className='schedule-label'>Date</label>
                <Form size='tiny'>
                  <Form.Group>
                    <Form.Field required width={16}>
                      <Dropdown fluid search selection options={AllDays()} className={'clearable-fix schedule-days'} placeholder='Day' id='day' name='day' onChange={handleChangeDay} value={`${context.config.day}`} />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </div>
              <div className='col-md-12'>
                <label className='schedule-label'>Time</label>
                {/* <TimePicker placeholder={'Time'} className={'time-picker-schedule'} use12Hours format="h:mm a" value={context.config.hour.value} onChange={(time, timeString) => { handleChangeDateTime({ value: time, timeString, id: 'hour' }); }} /> */}
                <Datetime
                  inputProps={{ placeholder: "Time Picker Here" }}
                  dateFormat={false}
                  value={context.config.hour.value}
                  onChange={(time, timeString) => { handleChangeDateTime({ value: time, timeString, id: 'hour' }); }} />

              </div>
              <div className='col-md-12'>
                <label className='schedule-label'>Time Zone</label>
                <p className='text-muted'>{context.config.timeZoneStr}</p>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-12'>
                <label className='schedule-label'>Send To:</label>
                <div className='row'>
                  <div className='col-md-9'>
                    <Form size='tiny'>
                      <Form.Group>
                        <Form.Field required width={16} size={'tiny'}>
                          <Input size='tiny' fluid placeholder='Correo electrónico' id='sendTo' name='sendTo' value={email} onChange={onChangeEmail} onKeyPress={onADD} />
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </div>
                  <div className='col-md-3 '>
                    <CircleButton onClick={onAddEmail} icon={'add'} disabled={!emailAdd} />
                  </div>
                </div>

              </div>
              <div className='col-md-12'>
                <label className='schedule-label'>Mail List</label>
                <div className='d-flex flex-column email'>
                  {
                    context.emailList.map((email, index) => {
                      return (
                        <div className='d-flex align-items-center email__container' key={index}>
                          <div className='email__item'>
                            <label>{email}</label>
                          </div>
                          <div className='email__action'>
                            <CircleButton disabled={false} color={'danger'} icon={'delete'} onClick={() => { context.remove_email(email); }} />
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ScheduleReport;